import { Dispatch, SetStateAction } from "react"
import { Grid, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { CreateOrderDialogFlow, CreateOrderDialogType, SelectedMainUserState } from "../../../createOrderTypes"
import { useCreateOrderDialogType } from "../../../hooks/useCreateOrderDialogType"
import { MeetingServiceConfig, DynamicConfigKey } from "../../form/formTypes"
import { UserType } from "../../../../../../modules/login/loginTypes"

import { DeliveryTimeSelector } from "../delivery/DeliveryTimeSelector"
import { ProductWish } from "../productWish/ProductWish"
import { ActionButtons } from "./ActionButtons"
import { ShopFiltersTypes } from "../ShopList"

const useStyles = makeStyles()((theme) => ({
    container: {
        padding: "1.25rem 1rem 1.5rem",
        background: theme.palette.common.white,
    },
    actionsWrap: {
        marginLeft: "auto",
        flex: "none",
    },
}))

type ShopListHeaderProps = Readonly<{
    filters: ShopFiltersTypes
    setFilters: Dispatch<SetStateAction<ShopFiltersTypes>>
    meetingServiceConfiguration?: MeetingServiceConfig
    handleCloseMainDialog: () => void
    flowConfig?: CreateOrderDialogFlow
    dialogType: CreateOrderDialogType
    user: SelectedMainUserState
}>

export function ShopListHeader({
    filters,
    setFilters,
    meetingServiceConfiguration,
    handleCloseMainDialog,
    flowConfig,
    dialogType,
    user,
}: ShopListHeaderProps) {
    const { classes } = useStyles()
    const { isRefundOrder, isRegularOrder } = useCreateOrderDialogType(dialogType)

    const findProductWish = meetingServiceConfiguration?.sections
        .flatMap(({ groups }) => groups.flatMap(({ fields }) => fields))
        .find((field) => field.key === DynamicConfigKey.PRODUCT_WISH)?.active

    return (
        <Grid
            container
            alignItems="center"
            gap=".75rem"
            flexWrap="nowrap"
            justifyContent="space-between"
            className={classes.container}
        >
            {isRefundOrder ? (
                <>
                    {!!findProductWish && (
                        <Stack className={classes.actionsWrap}>
                            <ProductWish />
                        </Stack>
                    )}
                </>
            ) : (
                <>
                    {meetingServiceConfiguration && (
                        <DeliveryTimeSelector
                            meetingServiceConfiguration={meetingServiceConfiguration}
                            handleCloseMainDialog={handleCloseMainDialog}
                            flowConfig={flowConfig}
                            disabled={!isRegularOrder}
                            allowOutsideBusinessHours={user.userType === UserType.MERCHANT}
                        />
                    )}
                    <ActionButtons
                        filters={filters}
                        setFilters={setFilters}
                        isProductWish={!!findProductWish}
                        isRefundOrder={isRefundOrder}
                    />
                </>
            )}
        </Grid>
    )
}
